/// <reference path="../typings/jquery/jquery.d.ts" />

import { Injectable } from "@angular/core";

declare var $: JQueryStatic;

@Injectable()
export class JqueryExtensionsService {
  private safePlaceholder = "avoid-errors-with-invalid-selector";

  selectElement(selector: string) {
    return $(String(selector) || this.safePlaceholder);
  }

  eventOn(element: any, method: string, action: Function) {
    if (!(!!action && typeof action === "function" && action instanceof Function)) { return; }
    try {
      (element || $(this.safePlaceholder)).on(
        String(method) || this.safePlaceholder,
        action
      );
    } catch (ex) { } 
  }

  eventOff(element: any, method: string) {
    try { (element || $(this.safePlaceholder)).off(String(method) || this.safePlaceholder); } catch (ex) { }
  }

  tooltip(
    selector: string,
    container?: string,
    html?: boolean
  ) {
    let self = this.selectElement(String(container));

    self.tooltip({
      selector: String(selector) || this.safePlaceholder,
      html: !!html
    });

    return self;
  }

  selectpicker(
    selector: string,
    method?: string,
  ) {
    let self = this.selectElement(String(selector));

    self.selectpicker(method || "");

    return self;
  }

  dateTimePicker(
    selector: string,
    options?: Object
  ) {
    return this.selectElement(String(selector)).datetimepicker(options || "");
  }

  setMultipleSelection(
    id: string,
    options: Array<string>
  ) {
    this.selectElement('#' + id).selectpicker("val", options);
  }

  getMultipleSelection(
    event: JQueryEventObject,
    id: string
  ): Array<number> {
    let ret: Array<number> = [];

    this.selectElement('#' + id + ' option:selected').each(function () {
      let values: any = $(event.currentTarget).val(); // $(this).val()
      if (typeof values === "string") {
        if (!isNaN(Number(values))) {
          ret.push(Number(values));
        }
      }
      if (typeof values === "object") {
        values.forEach((i: any) => {
          if (typeof i === "string") {
            if (!isNaN(Number(i))) {
              ret.push(Number(i));
            }
          }
        });
      }
    });

    return ret;
  }

  slider(
    selector: string,
    formatter?: Function
  ) {
    let self = this.selectElement(String(selector));

    if (!(!!formatter)) {
      self.slider();
    } else {
      self.slider({ formatter: formatter });
    }

    return self;
  }

  bootstrapSwitch(
    selector: string,
    state: boolean,
    disabled: boolean
  ) {
    let self = this.selectElement(String(selector));
    self.bootstrapSwitch({ "state": state, "disabled": disabled, "onColor": "success", "offColor": "warning", size: "mini" });
    return self;
  }

  bootstrapSwitchChangeState(
    selector: string,
    state: boolean
  ) {
    let self = this.selectElement(String(selector));
    self.bootstrapSwitch("state", state);
  }

  bootstrapSwitchChangeDisabled(
    selector: string,
    disabled: boolean
  ) {
    let self = this.selectElement(String(selector));
    self.bootstrapSwitch("disabled", disabled);
  }

  focus(selector: string) {
    this.selectElement(selector).focus();
  }

  iCheckInit(selector: string) {
    let self = this.selectElement(String(selector));
    self.iCheck({
      checkboxClass: "icheckbox_flat-green",
      disabledCheckboxClass: "icheckbox_flat-aero"
    });
  }

  iCheck(selector: string, option: string) {
    let self = this.selectElement(String(selector));
    self.iCheck(option);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/jquery.service.ts